module.exports = __webpack_public_path__ + "images/img-1poGXR9.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/managers/90.jpg
// module id = 2025
// module chunks = 0